<!--
    @change="updateValue($event.target.checked)"
-->
<template>
    <div>
        <select :id="control.uniqueId"
                :class="styles.FORM.FORM_CONTROL"
                :name="control.name || control.uniqueId"
                @input="updateValue($event.target.value)"
                >
            <option value="AL" :selected="value === 'AL'">Alabama</option>
            <option value="AK" :selected="value === 'AK'">Alaska</option>
            <option value="AZ" :selected="value === 'AZ'">Arizona</option>
            <option value="AR" :selected="value === 'AR'">Arkansas</option>
            <option value="CA" :selected="value === 'CA'">California</option>
            <option value="CO" :selected="value === 'CO'">Colorado</option>
            <option value="CT" :selected="value === 'CT'">Connecticut</option>
            <option value="DE" :selected="value === 'DE'">Delaware</option>
            <option value="DC" :selected="value === 'DC'">District Of Columbia</option>
            <option value="FL" :selected="value === 'FL'">Florida</option>
            <option value="GA" :selected="value === 'GA'">Georgia</option>
            <option value="HI" :selected="value === 'HI'">Hawaii</option>
            <option value="ID" :selected="value === 'ID'">Idaho</option>
            <option value="IL" :selected="value === 'IL'">Illinois</option>
            <option value="IN" :selected="value === 'IN'">Indiana</option>
            <option value="IA" :selected="value === 'IA'">Iowa</option>
            <option value="KS" :selected="value === 'KS'">Kansas</option>
            <option value="KY" :selected="value === 'KY'">Kentucky</option>
            <option value="LA" :selected="value === 'LA'">Louisiana</option>
            <option value="ME" :selected="value === 'ME'">Maine</option>
            <option value="MD" :selected="value === 'MD'">Maryland</option>
            <option value="MA" :selected="value === 'MA'">Massachusetts</option>
            <option value="MI" :selected="value === 'MI'">Michigan</option>
            <option value="MN" :selected="value === 'MN'">Minnesota</option>
            <option value="MS" :selected="value === 'MS'">Mississippi</option>
            <option value="MO" :selected="value === 'MO'">Missouri</option>
            <option value="MT" :selected="value === 'MT'">Montana</option>
            <option value="NE" :selected="value === 'NE'">Nebraska</option>
            <option value="NV" :selected="value === 'NV'">Nevada</option>
            <option value="NH" :selected="value === 'NH'">New Hampshire</option>
            <option value="NJ" :selected="value === 'NJ'">New Jersey</option>
            <option value="NM" :selected="value === 'NM'">New Mexico</option>
            <option value="NY" :selected="value === 'NY'">New York</option>
            <option value="NC" :selected="value === 'NC'">North Carolina</option>
            <option value="ND" :selected="value === 'ND'">North Dakota</option>
            <option value="OH" :selected="value === 'OH'">Ohio</option>
            <option value="OK" :selected="value === 'OK'">Oklahoma</option>
            <option value="OR" :selected="value === 'OR'">Oregon</option>
            <option value="PA" :selected="value === 'PA'">Pennsylvania</option>
            <option value="RI" :selected="value === 'RI'">Rhode Island</option>
            <option value="SC" :selected="value === 'SC'">South Carolina</option>
            <option value="SD" :selected="value === 'SD'">South Dakota</option>
            <option value="TN" :selected="value === 'TN'">Tennessee</option>
            <option value="TX" :selected="value === 'TX'">Texas</option>
            <option value="UT" :selected="value === 'UT'">Utah</option>
            <option value="VT" :selected="value === 'VT'">Vermont</option>
            <option value="VA" :selected="value === 'VA'">Virginia</option>
            <option value="WA" :selected="value === 'WA'">Washington</option>
            <option value="WV" :selected="value === 'WV'">West Virginia</option>
            <option value="WI" :selected="value === 'WI'">Wisconsin</option>
            <option value="WY" :selected="value === 'WY'">Wyoming</option>
        </select>        
    </div>
</template>

<script>
    import BaseControlSkeleton from "../../skeletons/controls/BaseControlSkeleton";

    export default {
        name: "StatePickerControl",
        extends: BaseControlSkeleton,        
        props: {
            siteID: String            
        },

        data: () => ({            
            selectedValue: null,
            textKey: '',
            valueKey: ''
        }),

        watch: {
            control: {
                deep: true,
                handler(controlObj) {
                    /*console.log(`in opendentaldata control watch, handler called with val: ${JSON.stringify(controlObj)}`);
                    if(controlObj.dataType)
                        this.retrieveRadioOptionsList();
                    */
                },
            },
            value(val) {                
                //console.log(`in statepicker control watch, value called with val: ${JSON.stringify(val)}`);                
                this.setValue(val);
            }            
        },

        created() {    
            //this.retrieveRadioOptionsList();        
        },

        mounted() {            
        },

        beforeDestroy() {            
        },

        methods: {
            update(e) {                
            },

            setValue(val) { 
                //console.log(`setValue called with ${JSON.stringify(val)}`);
                this.selectedValue = val;
            },
        },
    }
</script>